import { INdaData } from "../../../types/ndaData.interface";
import { IPermissionsContext } from "../../../types/user/permissions/ipermissions-context/ipermissions-context.interface";
import { IUser } from "../../../types/user/iuser.interface";
import { createEmptyUser } from "../../../features/user/types/user.functions";
import { toString } from "../../../utils/type.utils";

import {
  IBriefOwner,
  ICampaignBriefData,
} from "./campaign-brief-state/campaign-brief-state.interface";

export const createCampaignBriefPermissionsContext = (
  brief: ICampaignBriefData,
  user: IUser,
  executionOwnerId: number,
  workorderOwnerId: number
): IPermissionsContext => {
  return {
    userId: user.id,
    userGroups: user.groups,
    pageType: "campaign-briefs",
    executionOwnerId,
    workorderOwnerId,
    briefOwnerId: brief.briefOwner ? brief.briefOwner.id : 0,
    pageOwnerId: brief.briefOwner ? brief.briefOwner.id : 0,
    pageStatus: brief.status,
    reviewers: brief.reviewers,
    merchOwners: brief.dependentUserDetails
      ? brief.dependentUserDetails.executionBriefMerchOwners
      : [],
    parentReviewers: [],
    contentCreators: [],
  };
};

export const getBriefOwnerFullName = (briefOwner: IBriefOwner): string =>
  `${briefOwner.firstName} ${briefOwner.lastName}`;

export function getNdaDataFromCampaignBrief(brief: ICampaignBriefData): INdaData {
  return {
    isUnderNda: brief.isUnderNda || false,
    underNdaUserDetails: brief.underNdaUserDetails,
  };
}

export function campaignBriefNormaliseFormData(data: ICampaignBriefData): ICampaignBriefData {
  return {
    ...data,
    additionalCreativeRequirementsDetails: data.additionalCreativeRequirementsDetails ?? "",
    additionalDetails: data.additionalDetails ?? "",
    announcementDate: data.announcementDate ?? "",
    areVendorAssetsProvided: !!data.areVendorAssetsProvided,
    audience: data.audience ?? "",
    brandFrameworkSupport: data.brandFrameworkSupport ?? "",
    briefOwner: data.briefOwner ?? createEmptyUser(),
    context: data.context ?? "",
    customerMessage: data.customerMessage ?? "",
    customerTakeaway: data.customerTakeaway ?? "",
    endAt: data.endAt ?? "",
    executionPlansDueAt: data.executionPlansDueAt ?? "",
    hasVendorCommitment: data.hasVendorCommitment ?? false,
    insight: data.insight ?? "",
    isExclusive: !!data.isExclusive,
    isInstore: !!data.isInstore,
    isMap: !!data.isMap,
    isOnline: !!data.isOnline,
    isRegional: !!data.isRegional,
    launchDate: data.launchDate ?? "",
    languages: data.languages ?? [],
    legalRequirementsDetails: data.legalRequirementsDetails ?? "",
    linkedCampaignBriefsDetails: data.linkedCampaignBriefsDetails ?? [],
    mandatoryCreativeRequirementsDetails: data.mandatoryCreativeRequirementsDetails ?? "",
    marketingChannels: data.marketingChannels ?? [],
    marketingSupportLevel: data.marketingSupportLevel ?? "",
    messagingPrimary: data.messagingPrimary ?? "",
    messagingSecondary: data.messagingSecondary ?? "",
    numberOfStores: data.numberOfStores ?? "",
    objectives: data.objectives ?? "",
    offerDetails: data.offerDetails ?? "",
    opportunity: data.opportunity ?? "",
    otherMarketingChannels: data.otherMarketingChannels ?? "",
    overview: data.overview ?? "",
    overviewAttachments: data.overviewAttachments ?? [],
    preOrderDate: data.preOrderDate ?? "",
    previousResults: data.previousResults ?? "",
    regions: data.regions ?? [],
    startAt: data.startAt ?? "",
    status: data.status ?? "",
    targetSalesForecast: toString(data.targetSalesForecast),
    targetTimeframe: toString(data.targetTimeframe),
    tonality: data.tonality ?? "",
    underNdaUsers: data.underNdaUsers ?? [],
    vendorAssetsLocation: data.vendorAssetsLocation ?? "",
    warehouseEta: data.warehouseEta ?? "",
  };
}
